import get from 'lodash.get';

const getTextDecorations = (state) =>
  get(state, 'ws.template.meta.customization.textDecorations', []);

export default getTextDecorations;
